import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Typography } from '@mui/material';
import { MotionContainer, varBounce } from '../components/animate';
import { useSlugContext } from 'src/hooks/slugProvider';
import NotFoundImage from 'src/assets/404/EN_CONSTRUCCIÓN.svg';
import { useLocales } from 'src/locales';

// ----------------------------------------------------------------------

export default function Page404() {
  const { slug_id: slug } = useSlugContext();
  const { translate: t } = useLocales();
  const mockedSlug = slug;
  return (
    <>
      <Helmet>
        <title> 404 Page Not Found | Ambigú</title>
      </Helmet>

      <MotionContainer
        sx={{
          p: '25px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <m.div variants={varBounce().in}>
          <Typography fontWeight={700} fontSize="7rem">
            404
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography variant="h3" textAlign="center">
            {t('notFound.heading')}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }} paragraph textAlign="center">
            {t('notFound.description')}
          </Typography>
        </m.div>

        <img
          src={NotFoundImage}
          style={{ marginBottom: '5rem' }}
          width={200}
          alt={t('notFound.heading')}
        />
      </MotionContainer>
    </>
  );
}

export function Page404Custom() {
  return (
    <>
      <Helmet>
        <title> 404 Page Not Found | Ambigú</title>
      </Helmet>

      <MotionContainer
        sx={{
          p: '25px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <m.div variants={varBounce().in}>
          <Typography fontWeight={700} fontSize="7rem">
            404
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography variant="h3" textAlign="center">
            {'Oido, esto no estaba previsto'}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }} paragraph textAlign="center">
            {'no podemos encontrar lo que buscas'}
          </Typography>
        </m.div>

        <img src={NotFoundImage} style={{ marginBottom: '5rem' }} width={200} />
      </MotionContainer>
    </>
  );
}

export function Page404PaymentLink() {
  const { translate: t } = useLocales();

  return (
    <>
      <Helmet>
        <title> 404 Page Not Found | Ambigú</title>
      </Helmet>

      <MotionContainer
        sx={{
          p: '25px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <m.div variants={varBounce().in}>
          <Typography fontWeight={700} fontSize="7rem">
            404
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography variant="h3" textAlign="center">
            {t('notFound.payment_link_description')}
          </Typography>
        </m.div>

        <img src={NotFoundImage} style={{ marginBottom: '5rem' }} width={200} />
      </MotionContainer>
    </>
  );
}
